import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';

export const getIsPlanErknmStatusInProcess = (status: ErknmPlanStatusesEnum | null | undefined) =>
  status === ErknmPlanStatusesEnum.IN_PROCESS;
export const getIsPlanErknmStatusUnderConsideration = (status: ErknmPlanStatusesEnum | null | undefined) =>
  status === ErknmPlanStatusesEnum.UNDER_CONSIDERATION;
export const getIsPlanErknmStatusConsidered = (status: ErknmPlanStatusesEnum | null | undefined) =>
  status === ErknmPlanStatusesEnum.CONSIDERED;
export const getIsPlanErknmStatusApproved = (status: ErknmPlanStatusesEnum | null | undefined) =>
  status === ErknmPlanStatusesEnum.APPROVED;
